/* ============================================================
   data.ts — шаги рабочего процесса для WorkflowSection
   Страница /management — как работает система заявок
   ============================================================ */

/** Описание одного шага в рабочем процессе обработки заявки */
export interface WorkflowStep {
    /** Номер шага — строка "01", "02" и т.д. */
    step: string;
    /** Краткое название шага */
    title: string;
    /** Развёрнутое описание шага */
    description: string;
}

/** Последовательность шагов обработки заявок */
export const WORKFLOW_STEPS: WorkflowStep[] = [
    {
        step: "01",
        title: "Жилец подаёт заявку",
        description:
            "Через приложение или веб — в любое время суток. Фото, описание, категория.",
    },
    {
        step: "02",
        title: "Система уведомляет диспетчера",
        description:
            "Push-уведомление мгновенно. Заявка попадает в журнал с приоритетом.",
    },
    {
        step: "03",
        title: "Назначение исполнителя",
        description:
            "Диспетчер назначает специалиста одним кликом. Исполнитель видит задачу на телефоне.",
    },
    {
        step: "04",
        title: "Работа выполнена",
        description:
            "Исполнитель отмечает выполнение. Жилец получает уведомление и ставит оценку.",
    },
];
